export default __webpack_public_path__ + "static/media/welpentreffen_33.37df65bc.jpg";